import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentDmsEnum on DmsEnum {
    id
    name
    description
    note
    terms {
      id
    }
    entries {
      id
      name
      description
    }
  }
`

/**
 * Transformer for the {@link graphql.schema.FragmentDmsEnum} to the
 * {@link ents.core.dms.models.Enum.Entry}.
 */
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDmsEnumFragment,
  ents.core.dms.models.Enum
>({
  description: transformers.PASS_THROUGH,
  entries: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(
      graphql.transformers.OUT.object({
        description: transformers.PASS_THROUGH,
        id: transformers.PASS_THROUGH,
        name: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
      }),
      { onNullish: 'remove' },
    ),
    [],
  ),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  name: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  note: transformers.PASS_THROUGH,
  terms: () => undefined,
})
